export const getDateKey = (value) => {
  if (typeof value?.format === 'function') {
    return value.format('YYYY-MM-DD');
  }

  const date = new Date(value?._d ?? value);
  if (Number.isNaN(date.getTime())) return null;
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

export const isSingleDayRange = (dates) => {
  const start = getDateKey(dates?.start);
  const end = getDateKey(dates?.end);
  return Boolean(start && end && start === end);
};